import React from "react";
import { ThePalaceData } from "../../../../components/template/CustomTemplate/Pages/ThePalace";
import CustomTemplates from "../../Deals/CustomTemplate";

const ThePalacePage = () => {
  return <CustomTemplates slug={"the-palace"} attributes={ThePalaceData} />;
};

export default ThePalacePage;
